import { render, staticRenderFns } from "./SiteFooter.vue?vue&type=template&id=2f55e5e4&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SiteFooter.vue"
export default component.exports